const types = {
  SET_LISTA_TIPOS_DOCUMENTO: 'SET_LISTA_TIPOS_DOCUMENTO',
  SET_LISTA_TIPO_INTERESSADO: 'SET_LISTA_TIPO_INTERESSADO',
  SET_LISTA_INTERESSADOS: 'SET_LISTA_INTERESSADOS',
  SET_TIPO_INTERESSADO: 'SET_TIPO_INTERESSADO',
  SET_INTERESSADO: 'SET_INTERESSADO',
  SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO: 'SET_LISTA_TIPO_RESPONSAVEL_TRAMITACAO',
  SET_LISTA_RESPONSAVEL_TRAMITACAO: 'SET_LISTA_RESPONSAVEL_TRAMITACAO',
  SET_TIPO_RESPONSAVEL_TRAMITACAO: 'SET_TIPO_RESPONSAVEL_TRAMITACAO',
  SET_RESPONSAVEL_TRAMITACAO: 'SET_RESPONSAVEL_TRAMITACAO',
  SET_LISTA_DOCUMENTOS: 'SET_LISTA_DOCUMENTOS',
  SET_LISTA_UNIDADES_PROCEDENCIA: 'SET_LISTA_UNIDADES_PROCEDENCIA',
  SET_LISTA_SERVIDORES_PROCEDENCIA: 'SET_LISTA_SERVIDORES_PROCEDENCIA',
  EXIBIR_DIALOG_INTERESSADO: 'EXIBIR_DIALOG_INTERESSADO',
  ESCONDER_DIALOG_INTERESSADO: 'ESCONDER_DIALOG_INTERESSADO',
  EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO: 'EXIBIR_DIALOG_RESPONSAVEL_TRAMITACAO',
  ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO: 'ESCONDER_DIALOG_RESPONSAVEL_TRAMITACAO',
  SET_BUSCANDO_DOCUMENTOS: 'SET_BUSCANDO_DOCUMENTOS',
  SHOW_GLOBAL_LOADING: 'ui/SHOW_GLOBAL_LOADING',
  HIDE_GLOBAL_LOADING: 'ui/HIDE_GLOBAL_LOADING',
  SHOW_SNACKBAR: 'ui/SHOW_SNACKBAR',
  HIDE_SNACKBAR: 'ui/HIDE_SNACKBAR'
}

export default types
